export default class Submenu {
    constructor() {
        this.events();
    }

    // Set up the events for the submenu
    events() {
        return $(document).on('click', '.sub-nav .sub-toggle a', (e) => {
            e.preventDefault();
            this.toggleNav();
        });
    }

    // Show/hide the submenu
    toggleNav() {
        return $('.sub-nav').toggleClass('open');
    }
};

